import React, {useState, useEffect} from "react";
import {Container, Card} from "react-bootstrap";
import "./VendorCLAssignment.css";
import axios from "../../util/Axios/AxiosInstance";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as ReactBootStrap from "react-bootstrap";
import filterFactory, {
    numberFilter, textFilter,
} from "react-bootstrap-table2-filter";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import edit from "../../../images/edit.png";
import TableActionIcon from "../../util/TableActionIcon";
import AOS from "aos";
import "aos/dist/aos.css";
import Skeleton from "react-loading-skeleton";

function VendorCLAssignmentList({HandleEvent, HandleEventGetId}) {
    const [tableData, setTableData] = useState([{
        transactionDate: <Skeleton/>,
        deptName: <Skeleton/>,
        subDeptName: <Skeleton/>,
        vendorName: <Skeleton/>,
        shiftName: <Skeleton/>,
        maleCount: <Skeleton/>,
        femaleCount: <Skeleton/>,
        vendorAssignedTotalCount: <Skeleton/>,
        labourDob: <Skeleton/>
    }, {
        transactionDate: <Skeleton/>,
        deptName: <Skeleton/>,
        subDeptName: <Skeleton/>,
        vendorName: <Skeleton/>,
        shiftName: <Skeleton/>,
        maleCount: <Skeleton/>,
        femaleCount: <Skeleton/>,
        vendorAssignedTotalCount: <Skeleton/>,
        labourDob: <Skeleton/>
    }, {
        transactionDate: <Skeleton/>,
        deptName: <Skeleton/>,
        subDeptName: <Skeleton/>,
        vendorName: <Skeleton/>,
        shiftName: <Skeleton/>,
        maleCount: <Skeleton/>,
        femaleCount: <Skeleton/>,
        vendorAssignedTotalCount: <Skeleton/>,
        labourDob: <Skeleton/>
    }, {
        transactionDate: <Skeleton/>,
        deptName: <Skeleton/>,
        subDeptName: <Skeleton/>,
        vendorName: <Skeleton/>,
        shiftName: <Skeleton/>,
        maleCount: <Skeleton/>,
        femaleCount: <Skeleton/>,
        vendorAssignedTotalCount: <Skeleton/>,
        labourDob: <Skeleton/>
    }, {
        transactionDate: <Skeleton/>,
        deptName: <Skeleton/>,
        subDeptName: <Skeleton/>,
        vendorName: <Skeleton/>,
        shiftName: <Skeleton/>,
        maleCount: <Skeleton/>,
        femaleCount: <Skeleton/>,
        vendorAssignedTotalCount: <Skeleton/>,
        labourDob: <Skeleton/>
    }, {
        transactionDate: <Skeleton/>,
        deptName: <Skeleton/>,
        subDeptName: <Skeleton/>,
        vendorName: <Skeleton/>,
        shiftName: <Skeleton/>,
        maleCount: <Skeleton/>,
        femaleCount: <Skeleton/>,
        vendorAssignedTotalCount: <Skeleton/>,
        labourDob: <Skeleton/>
    }, {
        transactionDate: <Skeleton/>,
        deptName: <Skeleton/>,
        subDeptName: <Skeleton/>,
        vendorName: <Skeleton/>,
        shiftName: <Skeleton/>,
        maleCount: <Skeleton/>,
        femaleCount: <Skeleton/>,
        vendorAssignedTotalCount: <Skeleton/>,
        labourDob: <Skeleton/>
    },]);
    const [loading, setLoading] = useState(false);
    const [vendorAccount, setVendorAccount] = useState(false);
    const [role, setRole] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const current = new Date();
    const date = `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}`;
    const genderSpecific = localStorage.getItem("genderSpecific");
    const [genderBased, setGenderBased] = useState(false);
    // console.log(date);
    const options = {
        onSizePerPageChange: (sizePerPage, page) => {
            setPageSize(sizePerPage);
            // setPageNumber(page);
        }, onPageChange: (page, sizePerPage) => {
            // setPageSize(sizePerPage);
            setPageNumber(page);
        },
    };
    const getVendorTransactionDetailsByBranchId = async (branchId) => {
        try {
            const data = await axios.get("getVendorTransactionDetailsByBranchId/" + branchId + "/" + date);
            setTableData(data.data);
            // console.log(data.data);
            setLoading(true);
        } catch (e) {
        }
    };

    const getVendorTransactionDetailsByVendorIdAndBranchId = async (vendorId, branchId, date) => {
        try {
            const data = await axios.get("getVendorTransactionDetailsByVendorIdAndBranchId/" + vendorId + "/" + branchId + "/" + date);
            setTableData(data.data);
            // console.log(data.data);
            setLoading(true);
        } catch (e) {
        }
    };

    useEffect(() => {
        AOS.init();
    })

    useEffect(() => {
        const branchId = localStorage.getItem("branchId");
        const userrole = localStorage.getItem("role");
        if (genderSpecific == "true" || genderSpecific == "TRUE" || genderSpecific == "True") {
            setGenderBased(true);
        }

        setRole(userrole);
        switch (role) {
            case "Admin":
                getVendorTransactionDetailsByBranchId(branchId);
                setVendorAccount(true);
                break;
            case "SuperAdmin":
                getVendorTransactionDetailsByBranchId(branchId);
                setVendorAccount(true);
                break;
            case "Vendor":
                const vid = localStorage.getItem("vendorId");
                getVendorTransactionDetailsByVendorIdAndBranchId(vid, branchId, date);
                setVendorAccount(true);
                break;
            case "Security":
                getVendorTransactionDetailsByBranchId(branchId);
                setVendorAccount(true);
                break;
        }
    }, [role]);

    function doSomething() {

    }

    const columns = [{
        dataField: "clTransactionId", text: "S No.", formatter: (cell, row, rowIndex) => {
            return (pageNumber - 1) * pageSize + (rowIndex + 1);
        }, headerStyle: (colum, colIndex) => {
            return {width: "60px", textAlign: "center"};
        },
    }, // { dataField: "clTransactionId", text: "ID" , sort: true, filter: textFilter(), headerStyle: (colum, colIndex) => {
        //     return { width: '60px', textAlign: 'center' };
        //   } },
        // { dataField: "transactionDate", text: "TransactionDate" , sort: true },
        // { dataField: "deptName", text: "Department", sort: true, filter: textFilter()},
        // { dataField: "subDeptName", text: "SubDepartment", sort: true, filter: textFilter() },
        // { dataField: "shiftName", text: "shift", sort: true, filter: textFilter(), headerStyle: (colum, colIndex) => {
        //     return { width: '80px', textAlign: 'center' };
        //   } },
        // { dataField: "vendorName", text: "VendorName", sort: true, filter: textFilter() },
        // { dataField: "labourerName", text: "LabourerName", sort: true, filter: textFilter()},
        // { dataField: "labourerGender", text: "LabourerGender", sort: true, filter: textFilter(), headerStyle: (colum, colIndex) => {
        //     return { width: '80px', textAlign: 'center' };
        //   }},
        // { dataField: "createdBy", text: "CreatedBy", sort: true, filter: textFilter() },
        // { dataField: "createdDate", text: "CreatedDate", sort: true },

        {
            dataField: "transactionDate", text: "Date", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
        }, {
            dataField: "deptName", text: "Department", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
        }, {
            dataField: "subDeptName", text: "SubDepartment", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
        }, {dataField: "shiftName", text: "Shift", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,},
         {
            dataField: "vendorName", text: "Vendor", hidden: vendorAccount, sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
        }, {
            dataField: "maleCount", text: "MaleCount", sort: true, hidden: !genderBased, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
        }, {
            dataField: "femaleCount", text: "FemaleCount", sort: true, hidden: !genderBased, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
        }, {
            dataField: "vendorAssignedTotalCount",
            text: "Assigned Count",
            hidden: genderBased,
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        }, {
            dataField: "labourDob",
            text: "Actions",
            isDummyField: true,
            hidden: !vendorAccount,
            formatter: (cellContent, row) => {
                return (
                    <TableActionIcon
                        src={edit}
                        title="Edit CL request"
                        disabled={!loading}
                        onClick={() => HandleEventGetId(6.1, row)}
                    />
                );
            },
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },];

    return (<Card className="cardStyl">
            <Container fluid className="px-0">
                <div className={"mt-2"}>
                    {/*<h2>Laborer Master</h2>*/}
                    <h5 className={"priColor"}> CL Requested List</h5>
                </div>
                <div>
                    {/* <div className={"row"}>
                    <div style={{marginBottom:"10px"}}>
                        {vendorAccount?<button className={"btn btn-primary"} variant="primary"
                                style={{ float: "right" }}
                                onClick={(e)=> HandleEvent(6.1)}>
                            Add New
                        </button>
                        :""}
                    </div>
                </div> */}
                    <div data-aos="zoom-in-right" data-aos-duration="550">
                        <BootstrapTable
                            bootstrap4
                            keyField="clTransactionId"
                            data={tableData}
                            columns={columns}
                            wrapperClasses="table-responsive"
                            pagination={paginationFactory(options)}
                            filter={filterFactory()}
                        />
                    </div>
                </div>
            </Container>
        </Card>);
}

export default VendorCLAssignmentList;
